import { Zap, Shield, Clock, Layers } from "lucide-react";

const DEVICE_IMG = "/images/cami_p2_img2.jpeg";

const highlights = [
  {
    icon: Zap,
    label: "Max Power",
    value: "25W",
    desc: "Per pulse output",
  },
  {
    icon: Shield,
    label: "Gold-Plated",
    value: "24K",
    desc: "Microneedle electrodes",
  },
  {
    icon: Clock,
    label: "Downtime",
    value: "12h",
    desc: "Minimal recovery",
  },
  {
    icon: Layers,
    label: "Depth Layers",
    value: "Up to 5",
    desc: "Stratification levels",
  },
];

export default function TechnologyOverview() {
  return (
    <section
      id="technology"
      data-testid="technology-section"
      className="py-24 lg:py-32 px-6 lg:px-12"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="reveal mb-20">
          <p
            className="text-xs tracking-[0.3em] uppercase mb-4"
            style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
          >
            Revolutionary Design
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-white leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            One Handle.<br />
            <span className="text-white/40">Every Modality.</span>
          </h2>
        </div>

        {/* Main Grid */}
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Text */}
          <div className="reveal space-y-8">
            <p
              className="text-base lg:text-lg text-white/50 leading-relaxed tracking-wide"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Cami X integrates the capabilities of the industry's leading RF microneedling
              platforms into a single, elegant system. With interchangeable treatment heads
              spanning non-insulated vacuum-assisted, insulated layered, common-pole,
              and non-invasive modalities — Cami X eliminates the need for multiple devices.
            </p>

            <p
              className="text-base lg:text-lg text-white/50 leading-relaxed tracking-wide"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Featuring dual RF frequencies at <span className="text-white">2.2MHz</span> and{" "}
              <span className="text-white">700KHz</span>, with adjustable penetration depths up to{" "}
              <span className="text-white">7.0mm</span> and gold-plated microneedle electrodes,
              the Cami X delivers precision energy exactly where it's needed.
            </p>

            <div className="gold-line w-24 mt-8" />

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              {highlights.map((item) => (
                <div key={item.label} className="stat-card p-5" data-testid={`stat-${item.label.toLowerCase().replace(/\s/g, "-")}`}>
                  <item.icon size={18} className="mb-3" style={{ color: "#D4AF37" }} />
                  <div
                    className="text-2xl font-light text-white mb-1"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {item.value}
                  </div>
                  <div
                    className="text-xs tracking-[0.1em] uppercase text-white/40"
                    style={{ fontFamily: "'Manrope', sans-serif" }}
                  >
                    {item.label}
                  </div>
                  <div className="text-xs text-white/25 mt-1" style={{ fontFamily: "'Manrope', sans-serif" }}>
                    {item.desc}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Device Image */}
          <div className="reveal flex justify-center">
            <div className="relative overflow-hidden rounded-sm border border-white/10">
              <img
                src={DEVICE_IMG}
                alt="Cami X Device - Microneedling RF Machine"
                className="relative w-full max-w-lg object-cover"
                data-testid="device-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C]/40 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
